import { Parser } from '@json2csv/plainjs'

export const convertToCSV = (arrayObjects, options) => {
  const parser = new Parser(options)
  return parser.parse(arrayObjects)
}
